import { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAV_GROUPS = [
  {
    label: 'المبيعات',
    items: [
      { to: '/',           icon: '⊞', label: 'الرئيسية',        roles: ['admin','sales_manager','sales_employee','warehouse','production_manager'] },
      { to: '/customers',  icon: '◎', label: 'العملاء',          roles: ['admin','sales_manager','sales_employee'] },
      { to: '/orders',     icon: '◈', label: 'الطلبات',          roles: ['admin','sales_manager','sales_employee'] },
      { to: '/payments',   icon: '◇', label: 'الدفعات',          roles: ['admin','sales_manager'] },
      { to: '/shipments',  icon: '◁', label: 'الشحنات',          roles: ['admin','sales_manager','sales_employee'] },
      { to: '/tasks',      icon: '◻', label: 'المهام',           roles: ['admin','sales_manager','sales_employee'] },
    ]
  },
  {
    label: 'المخزون والإنتاج',
    items: [
      { to: '/inventory',  icon: '▣', label: 'المخزون',          roles: ['admin','sales_manager','warehouse'] },
      { to: '/suppliers',  icon: '🏭', label: 'الموردون',         roles: ['admin','sales_manager','warehouse'] },
      { to: '/products',   icon: '▤', label: 'المواد الأولية',  roles: ['admin','sales_manager','warehouse'] },
      { to: '/bom',        icon: '◈', label: 'وصفات الإنتاج',   roles: ['admin','sales_manager'] },
      { to: '/finished-inventory', icon: '🌸', label: 'المنتجات الجاهزة', roles: ['admin','sales_manager','warehouse','production_manager'] },
      { to: '/production', icon: '▦', label: 'الإنتاج',          roles: ['admin','sales_manager','production_manager'] },
    ]
  },
  {
    label: 'الإدارة',
    items: [
      { to: '/reports',    icon: '◫', label: 'التقارير',         roles: ['admin','sales_manager'] },
      { to: '/users',      icon: '◉', label: 'المستخدمون',       roles: ['admin'] },
      { to: '/logs',       icon: '◌', label: 'سجل النظام',       roles: ['admin','sales_manager'] },
      { to: '/import',     icon: '▽', label: 'استيراد بيانات',   roles: ['admin'] },
    ]
  }
];

const ROLE_LABEL = {
  admin: 'مدير النظام',
  sales_manager: 'مدير مبيعات',
  sales_employee: 'موظف مبيعات',
  warehouse: 'مسؤول المخزن',
  production_manager: 'مسؤول الإنتاج',
};

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => { setOpen(false); }, [location.pathname]);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);
  useEffect(() => {
    const onResize = () => { if (window.innerWidth > 768) setOpen(false); };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div className="layout">
      <div className="mobile-topbar">
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div className="sidebar-logo" style={{ width:32, height:32, fontSize:'1rem' }}>🌸</div>
          <span style={{ color:'#fff', fontWeight:700, fontSize:'0.9rem' }}>Jasmine</span>
        </div>
        <button className={`hamburger ${open ? 'open' : ''}`} onClick={() => setOpen(o => !o)} aria-label="القائمة">
          <span className="bar"/><span className="bar"/><span className="bar"/>
        </button>
      </div>

      <div className={`sidebar-overlay ${open ? 'open' : ''}`} onClick={() => setOpen(false)} />

      <aside className={`sidebar ${open ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">🌸</div>
          <div>
            <div className="sidebar-title">Jasmine Perfumes</div>
            <div className="sidebar-sub">ERP System</div>
          </div>
        </div>

        <nav className="sidebar-nav">
          {NAV_GROUPS.map(group => {
            const visibleItems = group.items.filter(l => l.roles.includes(user?.role));
            if (!visibleItems.length) return null;
            return (
              <div key={group.label}>
                <div className="sidebar-section-label">{group.label}</div>
                {visibleItems.map(l => (
                  <NavLink
                    key={l.to} to={l.to} end={l.to === '/'}
                    className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
                  >
                    <span className="nav-icon" style={{ fontFamily:'monospace', fontSize:'0.85rem' }}>{l.icon}</span>
                    <span>{l.label}</span>
                  </NavLink>
                ))}
              </div>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <div className="user-card">
            <div className="user-avatar">{user?.name?.[0] || 'م'}</div>
            <div style={{ minWidth:0 }}>
              <div className="user-name truncate">{user?.name}</div>
              <div className="user-role">{ROLE_LABEL[user?.role] || user?.role}</div>
            </div>
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            <span>↩</span> تسجيل خروج
          </button>
        </div>
      </aside>

      <main className="main">
        <div className="content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
